/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-console */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config, { HTTP_STATUS } from "../../../config/config";

const itemListInitialState = {
  loading: null,
  data: [],
};

export const fetchItemListData = createAsyncThunk(
  "tokkio/fetchItemListData",
  async (payload) => {
    const { data } = await axios.get(
      `${config.uiServerEndpoint}/menu/category/${payload}`
    );
    console.debug("get response: ", data);
    return data;
  }
);

const itemListSlice = createSlice({
  name: "itemList",
  initialState: itemListInitialState,
  extraReducers: {
    [fetchItemListData.pending](state) {
      state.loading = HTTP_STATUS.PENDING;
    },
    [fetchItemListData.fulfilled](state, { payload }) {
      state.loading = HTTP_STATUS.FULFILLED;
      state.data = payload;
    },
    [fetchItemListData.rejected](state) {
      state.loading = HTTP_STATUS.REJECTED;
    },
  },
});

export const itemListActions = itemListSlice.actions;
export default itemListSlice;
